// assets
import { IdcardOutlined } from '@ant-design/icons';

// icons
const icons = { IdcardOutlined };

// ==============================|| MENU ITEMS - CLIENTES ||============================== //

const clientes = {
  id: 'group-clientes',
  title: 'Clientes',
  type: 'group',
  children: [{ id: 'clientes', title: 'Clientes', type: 'item', url: '/clientes', icon: icons.IdcardOutlined, permission: 'clientes.read' }]
};

export default clientes;
